(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    const initVainioMobileAtc = (bar) => {
    if (bar.dataset.initialized === 'true') return;

    const root = bar.closest('section');
    const primaryButton = root?.querySelector('product-form button[name="add"]');
    const stickyButton = bar.querySelector('.vainio-mobile-atc__button');
    const stickyPrice = bar.querySelector('.vainio-mobile-atc__price');
    const priceSource = root?.querySelector('[id^="price-"]');

    if (!root || !primaryButton || !stickyButton) return;

    bar.dataset.initialized = 'true';
    bar.hidden = false;

    const sync = () => {
      const primaryText = primaryButton.querySelector('span')?.textContent.trim();
      const priceText = priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim();
      const sizeInputs = root.querySelectorAll('variant-radios input[type="radio"], variant-selects select');
      const hasSizeChoice = sizeInputs.length === 0 || Array.from(sizeInputs).every((input) => {
        if (input.matches('select')) return Boolean(input.value);
        const group = input.closest('fieldset');
        return Boolean(group?.querySelector('input:checked'));
      });

      stickyButton.disabled = primaryButton.disabled;
      stickyButton.textContent = hasSizeChoice ? (primaryText || bar.dataset.addLabel) : bar.dataset.chooseLabel;
      if (priceText && stickyPrice) stickyPrice.textContent = priceText;
    };

    stickyButton.addEventListener('click', () => {
      if (stickyButton.disabled) {
        const picker = root.querySelector('variant-radios, variant-selects, .product-form__input');
        picker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      primaryButton.click();
    });

    root.addEventListener('change', () => window.setTimeout(sync, 0));
    new MutationObserver(sync).observe(primaryButton, { attributes: true, childList: true, subtree: true });
    if (priceSource) new MutationObserver(sync).observe(priceSource, { childList: true, subtree: true });

    new IntersectionObserver((entries) => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      bar.classList.toggle('is-visible', isMobile && !entries[0].isIntersecting);
    }, { threshold: 0.2 }).observe(primaryButton);

    const localizeReviews = () => {
      if (!document.documentElement.lang.toLowerCase().startsWith('fi')) return;
      document.querySelectorAll('.jdgm-rev-widg__title').forEach((node) => {
        if (node.textContent.trim() !== bar.dataset.reviewsTitle) node.textContent = bar.dataset.reviewsTitle;
      });
      document.querySelectorAll('.jdgm-write-rev-link').forEach((node) => {
        if (node.textContent.trim() !== bar.dataset.writeReview) node.textContent = bar.dataset.writeReview;
      });
    };

    const addOptionalChoicesHeading = () => {
      if (bar.dataset.readyCollegePants !== 'true') return;

      const firstChoice = root.querySelector('.product-personalizer .pplr-wrapper.pplr-checkbox');
      if (!firstChoice || firstChoice.querySelector('.vainio-optional-choices-heading')) return;

      const heading = document.createElement('label');
      heading.className = 'oindexlabel vainio-optional-choices-heading';
      heading.textContent = bar.dataset.optionalChoices;
      firstChoice.prepend(heading);
    };

    localizeReviews();
    addOptionalChoicesHeading();
    new MutationObserver(() => {
      localizeReviews();
      addOptionalChoicesHeading();
    }).observe(document.body, { childList: true, subtree: true });
    sync();
  };

  const initAllVainioMobileAtc = () => {
    document.querySelectorAll('[data-vainio-mobile-atc]').forEach(initVainioMobileAtc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVainioMobileAtc, { once: true });
  } else {
    initAllVainioMobileAtc();
  }
  } catch(e) { console.error(e); }
})();

})();
